import { observable, action } from "mobx";

class Modal {
  @observable showModal = false;
  @observable modalContent = ""; /// edit_attendee, create_atendee, search_attendee, email_template
  @observable parentId = "";
  @observable assignedTo = {};
  @observable updateComponent = false;
  @observable submitFunction = () => void 0;

  @action toggleModal = () => {
    this.showModal = !this.showModal;
  };

  @action modalContentSetter = type => {
    this.modalContent = type;
  };

  @action parentIdSetter = parent_id => {
    this.parentId = parent_id;
  };

  @action setAssignedTo = item => {
    this.assignedTo = item;
  };

  @action setSubmitFunction = func => {
    this.submitFunction = func;
  };

  @action toggleUpdateComponent = () => {
    this.updateComponent = !this.updateComponent;
    console.log("update toggled");
  };
}

export default new Modal();



// WEBPACK FOOTER //
// ./src/stores/Modal.js